import { useState } from "react"
import axios from "axios"

export default function ForgotPassword() {
  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState("")
  const [error, setError] = useState("")

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setMessage("")
    setError("")

    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/forgot-password`, {
        email,
      })

      // IMPORTANT: Always show generic success
      setMessage("If the email exists, a reset link was sent.")
    } catch (err) {
      setError("Something went wrong. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-container">
      <h1>Forgot password</h1>
      <p>Enter your email to receive a password reset link.</p>

      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="you@example.com"
          value={email}
          required
          onChange={(e) => setEmail(e.target.value)}
        />

        <button disabled={loading}>
          {loading ? "Sending..." : "Send reset link"}
        </button>
      </form>

      {message && <p className="info">{message}</p>}
      {error && <p className="error">{error}</p>}
    </div>
  )
}